import classes from './styles/index.module.scss';
import { ControlGroupProps } from '../types';
import { isUndefined } from '../../../predicates/type';

const classNamesByPositionMap = {
	left: classes.controlGroup_labelLeft,
	right: classes.controlGroup_labelRight,
};

export const getLabelPositionClass = (position: ControlGroupProps['position']) => {
	if (isUndefined(position)) {
		return '';
	}

	return classNamesByPositionMap[position];
};
